import updateCartViews from "./eCommerce";
export default class CartDelivery extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    events() {

        $(this.getSelectorFarmDeliveryRadio()).on('click', (e) => {
            this.checkShowTxt();

            this.updateCartType(1,$(this.getSelectorFarmDeliveryRadio()).data('my_cart'));

            $("#address_type").val("farm");
            $(this.getSelectorFarmDeliveryTab()).removeClass('d-none');
            $(this.getSelectorStandardDeliveryTab()).addClass('d-none');

            let enlev = $(this.getSelectorEnlevementDelivery());
            enlev.prop('checked', false);
            enlev.attr('disabled', 'disabled'); 
        });
        $(this.getSelectorStandardDeliveryRadio()).on('click', (e) => {
            this.checkShowTxt();

            this.updateCartType(0, $(this.getSelectorStandardDeliveryRadio()).data('my_cart'));
            $("#address_type").val("standard");
            $(this.getSelectorFarmDeliveryTab()).addClass('d-none');
            $(this.getSelectorStandardDeliveryTab()).removeClass('d-none');

            let enlev = $(this.getSelectorEnlevementDelivery());
            enlev.removeAttr('disabled', '');
        });

        $(this.getSelectorEditFarmAddress()).on('click', (e) => {
            $(this.getSelectorBlocFarmAddress()).addClass('d-none');
            $(this.getSelectorFormFarmAddress()).removeClass('d-none');
        });

        $(this.getSelectorExpressDelivery()).on('click', (e) => {
            if(this.checkShowTxt()) {
                if ($('#externe_div').length) {
                    $("#express_msg").addClass('d-none');
                    if ($(this.getSelectorExpressDelivery()).is(':checked')) {
                        $("#externe_div").addClass('d-none');
                        $("#externe_express_div").removeClass('d-none');
                    } else {
                        $("#externe_div").removeClass('d-none');
                        $("#externe_express_div").addClass('d-none');
                    }
                } else {
                    if($(this.getSelectorExpressDelivery()).is(':checked')){
                        $("#express_msg").removeClass('d-none');
                    }
                    else{
                        $("#express_msg").addClass('d-none');
                    }
                }
            }
            else{
                if($(this.getSelectorExpressDelivery()).is(':checked')){
                    $("#express_msg").removeClass('d-none');
                }
                else{
                    $("#express_msg").addClass('d-none');
                }
            }
        });

        $(this.getMeanSelector()).on('change', (e) => {
            $("#express_msg").addClass('d-none');

            if(this.checkShowTxt()) {
                if ($('#externe_div').length) {
                    $("#externe_div").removeClass('d-none');
                    $("#externe_express_div").addClass('d-none');
                }
            }

            let available = ($(e.target).data('express_available'));
            let xpres = $(this.getSelectorExpressDelivery());
            xpres.prop('checked', false);
            if (available == false) {
                xpres.attr('disabled', 'disabled'); 
            } else {
                xpres.removeAttr('disabled', '');
            }
        });

        $(this.getSelectorFarmDeliveryAddressCreate()).on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            HegydCore.sendRequest( $(this.getSelectorFarmDeliveryAddressCreate()).data('route'), 'PUT', {
                'firstname': $("[name='firstname']").val(),
                'lastname': $("[name='lastname']").val(),
                'phone': $("[name='phone']").val(),
                'company': $("[name='company']").val(),
                'address': $("[name='address']").val(),
                'additional_1': $("[name='additional_1']").val(),
                'additional_2': $("[name='additional_2']").val(),
                'zip': $("[name='zip']").val(),
                'city': $("[name='city']").val(),
                'country_id': $("[name='country_id']").val(),
                'cart_id': $(this.getSelectorFarmDeliveryAddressCreate()).data('cart_id'),
                'client_id': $(this.getSelectorFarmDeliveryAddressCreate()).data('client_id'),
                'return_templates'  : ['farm_address'],
            }, ( data ) => {
                this.updateCartViews( data );
                this.connectedCallback();
                toastr.success( data.message );
            }, ( data ) => {
                console.log(data.responseText)

                let test = JSON.parse(data.responseText);

                let message = "<ul>";

                for (const truc in test) {
                    message += '<li>'+test[truc][0] + '</li>';
                }

                message += "</ul>";
                
                toastr.error(message);
            });
        });

        $('#select_address').on('change', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            HegydCore.sendRequest( $(e.target).data('url'), 'POST', {
                'address_id': e.target.value,
                'cart_id': $(e.target).data('my_cart'),
                'client_id': $(e.target).data('client_id'),
                'return_templates': ['delivery_address'],
            }, ( data ) => {
                this.updateCartViews( data );
                this.connectedCallback();
                toastr.success( data.message );
            });
        })

        $('#recap_cart').on('click', (e) => {
            $('#comment_address').val($('#zone_comment').val());
        });

        $('#zone_comment').on('blur', (e) => {
            var current_value = $('#zone_comment').val();

            $('#zone_comment').val(current_value.substr(0,100));
        });
    }

    checkShowTxt(){
        //Permet de savoir si on doit afficher les textes pour les livraisons à l'etranger
        if ($('#standard-delivery:checked').length > 0 && $('#deliveryCountryId').val() != 75) {
            return true;
        }

        if ($('#farm-delivery:checked').length > 0 && $('#farmCountryId').val() != 75) {
            return true;
        }
        //Sinon on cache les champs
        $("#express_msg").addClass('d-none');
        $("#externe_div").addClass('d-none');
        $("#externe_express_div").addClass('d-none');

        return false;
    }

    updateCartType(type, cart_id){
        HegydCore.sendRequest( '/panier/change-type-address', 'POST', {
            'type': type,
            'cart_id': cart_id,
        }, ( data ) => {

        });
    }

    updateCartViews( data ) {
        updateCartViews(data);
    }

    getSelectorFarmDeliveryRadio() {
        return '#farm-delivery';
    }

    getSelectorEditFarmAddress() {
        return '#edit_farm_address';
    }
    getSelectorBlocFarmAddress() {
        return '#bloc_farm_address';
    }
    getSelectorFormFarmAddress() {
        return '#form_farm_address';
    }

    getSelectorStandardDeliveryRadio() {
        return '#standard-delivery';
    }

    getSelectorFarmDeliveryTab() {
        return '#farm_address';
    }

    getSelectorStandardDeliveryTab() {
        return '#delivery_address';
    }

    getSelectorFarmDeliveryAddressCreate() {
        return '#create-farm-address';
    }

    getSelectorExpressDelivery() {
        return '#express_delivery';
    }

    getSelectorEnlevementDelivery() {
        return '#not_available';
    }

    getMeanSelector() {
        return '[name="mean"]';
    }
}
